// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import IntegrationCallStateOverviewResourceViewModel from '../../../../viewModel/resource/IntegrationCallStateOverviewResourceViewModel';
import IntegrationCallStateOverviewResourceDTO from '../../dto/resource/IntegrationCallStateOverviewResourceDTO';

export default abstract class IntegrationCallStateOverviewResourceModel extends BaseModel<IntegrationCallStateOverviewResourceDTO> {
  /**
  * @type {date-time}
  */
  get integrationDay() { return this.dto.integrationDay; }
  set integrationDay(value) { this.dto.integrationDay = value; }
  /**
  * @type {int64}
  */
  get stateId() { return this.dto.stateId; }
  set stateId(value) { this.dto.stateId = value; }
  /**
  */
  get stateName() { return this.dto.stateName; }
  set stateName(value) { this.dto.stateName = value; }
  /**
  * @type {int32}
  */
  get count() { return this.dto.count; }
  set count(value) { this.dto.count = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    this.dto.integrationDay = qs.integrationday;
    value = Number.parseFloat(qs.stateid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.stateId = value;
    this.dto.stateName = qs.statename;
    value = Number.parseFloat(qs.count);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.count = value;
  }
}
